<div class="notification-preferences-wrapper">
  <!-- Loading State -->
  <div
    *ngIf="loading"
    class="loading-container flex items-center justify-center p-8"
  >
    <p i18n="@@loading">Loading notification preferences...</p>
  </div>

  <!-- Save Button (only shown in deferred save mode with edit permission) -->
  <div *ngIf="!loading && deferredSave && canEdit" class="save-button-container">
    <button
      class="save-button"
      [disabled]="!hasUnsavedChanges"
      [class.active]="hasUnsavedChanges"
      (click)="onSaveClick()"
      i18n="@@save_changes"
    >
      Save Changes
    </button>
  </div>

  <!-- Notification Preferences Table -->
  <div
    *ngIf="!loading && notificationRows?.length"
    class="L-tableUI__tableWrapper"
  >
    <table mat-table [dataSource]="dataSource" class="L-tableUI__table">
      <!-- Event Column -->
      <ng-container matColumnDef="event">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="event-column-header"
          i18n="@@event"
        >
          Event
        </th>
        <td mat-cell *matCellDef="let row" class="event-label">
          <div class="event-content">
            <span class="event-text">{{ row.label }}</span>
            <div *ngIf="row.hasInput" class="days-input-container">
              <input
                type="number"
                [(ngModel)]="row.inputValue"
                [disabled]="saving || !canEdit || (!row.emailEnabled && !row.smsEnabled)"
                (blur)="onInputValueChange(row)"
                class="days-input"
                min="1"
              />
              <span class="days-label" i18n="@@days">Days</span>
            </div>
          </div>
        </td>
      </ng-container>

      <!-- Email Column -->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef class="channel-header">
          <div class="header-content">
            <span class="header-title" i18n="@@email">Email</span>
            <mat-checkbox
              class="header-checkbox"
              [checked]="isAllSelected('email')"
              [indeterminate]="isSomeSelected('email')"
              [disabled]="saving || !canEdit || !isEmailEnabled"
              (change)="toggleAllPreferences('email')"
              color="primary"
              [matTooltip]="!canEdit ? noEditPermissionTooltip : !isEmailEnabled ? emailDisabledToolTip : ''"
              matTooltipPosition="above"
            ></mat-checkbox>
          </div>
        </th>
        <td mat-cell *matCellDef="let row" class="checkbox-cell">
          <mat-checkbox
            [checked]="row.emailEnabled"
            [disabled]="saving || !canEdit || !isEmailEnabled"
            (change)="onTogglePreference(row, 'email')"
            color="primary"
            [matTooltip]="!canEdit ? noEditPermissionTooltip : !isEmailEnabled ? emailDisabledToolTip : ''"
            matTooltipPosition="above"
          ></mat-checkbox>
        </td>
      </ng-container>

      <!-- SMS Column -->
      <ng-container matColumnDef="sms">
        <th mat-header-cell *matHeaderCellDef class="channel-header">
          <div class="header-content">
            <span class="header-title" i18n="@@sms">SMS</span>
            <mat-checkbox
              class="header-checkbox"
              [checked]="isAllSelected('sms')"
              [indeterminate]="isSomeSelected('sms')"
              [disabled]="saving || !canEdit || !isSmsEnabled"
              (change)="toggleAllPreferences('sms')"
              color="primary"
              [matTooltip]="!canEdit ? noEditPermissionTooltip : !isSmsEnabled ? smsDisabledToolTip : ''"
              matTooltipPosition="above"
            ></mat-checkbox>
          </div>
        </th>
        <td mat-cell *matCellDef="let row" class="checkbox-cell">
          <mat-checkbox
            [checked]="row.smsEnabled"
            [disabled]="saving || !canEdit || !isSmsEnabled"
            (change)="onTogglePreference(row, 'sms')"
            color="primary"
            [matTooltip]="!canEdit ? noEditPermissionTooltip : !isSmsEnabled ? smsDisabledToolTip : ''"
            matTooltipPosition="above"
          ></mat-checkbox>
        </td>
      </ng-container>

      <!-- Header and Row Declarations -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="preference-row"
      ></tr>
    </table>
  </div>
</div>
